import * as React from "react";
import { ILeadAction, LeadInterestedProject } from "../../../../core";
import AddInterestedProject from "../actions/AddInterestedProject";

interface IActionModalProps {
  onClose?: () => void;
  action?: ILeadAction;
  vehicle?: LeadInterestedProject;
  leadId?: string;
}

const InterestedProjectEdit: React.FunctionComponent<IActionModalProps> = (
  props
) => {
  return (
    <>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
          <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Edit Interested Project</h5>
            </div>
          </div>
        </div>
        <div className="container-fluid px-0 h-100">
          <AddInterestedProject
            className="col-4"
            onClose={props.onClose}
            onSuccess={() => {
              props.onClose?.();
            }}
            interestedProject={props.vehicle}
            leadId={props.leadId}
          ></AddInterestedProject>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default InterestedProjectEdit;
